import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { TicketReceiptComponent } from '../ticket-receipt/ticket-receipt.component';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  imports: [TicketReceiptComponent]
})
export class TicketTemplateComponent implements OnInit {

  public ticket: any = {}
  public ticketDetails: any[] = []
  public company: any = {}
  public office: any = null
  id: string | null = null
  type: string | null = null
  hidePrices = false

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.type = this.route.snapshot.paramMap.get('type');
    this.hidePrices = this.type === 'print-gift';
    this.getData(this.id);
  }

  getData(id: any): void {
    this.apiService.getById(Urls.urls.tickets, id).subscribe({
      next: (data: any) => {
        this.ticket = data.ticket;
        this.ticketDetails = data.ticket_details || [];
        this.getCompanyAndOffice();
      },
      error: (error: any) => {
        console.error('ERROR al obtener el ticket. ' + error);
      },
    });
  }

  getCompanyAndOffice(): void {
    this.apiService.getSelectors(Urls.urls.selectors, { companies: {}, offices: {} }).subscribe({
      next: (data: any) => {
        this.company = data.companies?.[0] || {};
        this.office = (data.offices || []).find((o: any) => o.id == this.ticket.office_id) || null;
        this.cdr.detectChanges();

        if (this.type === 'print' || this.type === 'print-gift') {
          window.print();
        }
      },
      error: (error: any) => {
        console.error('ERROR al obtener la compañía. ' + error);
      },
    });
  }
}
